import { APP_TOGGLE_MENU, APP_TOGGLE_NOTIFICATION_CENTER, IToggleMenu, IToggleNotificationCenter } from './types'

export const toggleMenu = (): IToggleMenu => ({
  type: APP_TOGGLE_MENU,
})

export const toggleNotificationCenter = (): IToggleNotificationCenter => ({
  type: APP_TOGGLE_NOTIFICATION_CENTER,
})
